import { jsx } from "react/jsx-runtime";
import { FileUploadWUT as FileUploadWUT$1 } from "../../../ui/file-upload/file-upload-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const FileUploadWUT = (props) => {
  const fieldType = FIELD_TYPES.FILE_UPLOAD;
  return /* @__PURE__ */ jsx(FileUploadWUT$1, { ...props, fieldType });
};
export {
  FileUploadWUT
};
//# sourceMappingURL=file-upload-wut.js.map
